var Modulsettings = (function () {
    'use strict';

    function Init() {
        $(".qrcode").toggle(AppData.modulsettings.showqrcode);

        if (AppData.modulsettings.showlostpass) {
            $(".lostpass").show();
        } else {
            $(".lostpass").hide();
        }

        if (AppData.modulsettings.floating_login_reg) {
            $("#landing nav").addClass("floating");

            let headerBg = hexToRgb("#FFFFFF");

            if ('floating_login_bg' in AppData.modulsettings) {
                headerBg = hexToRgb(AppData.modulsettings.floating_login_bg);
            }

            let headerOpacity = 1;
            if ('floating_login_opacity' in AppData.modulsettings) {
                headerOpacity = parseInt(AppData.modulsettings.floating_login_opacity) / 100;
            }
            $("#landing nav").css("background-color", 'rgba(' + headerBg.r + ',' + headerBg.g + ',' + headerBg.b + ', '+headerOpacity+')');
            $("#landing nav").css("color", AppData.modulsettings.floating_login_text);
        } else {
            $("#landing nav").removeClass("floating");
            $("#landing nav").css("background-color", "");
            $("#landing nav").css("color", "");
        }

        if (AppData.modulsettings.cdown_showonlogin == false) {
            $("#landing .countdown_bc").hide();
        } else {
            $("#landing .countdown_bc").show();
        }

        showCountDown(AppData.modulsettings.cdown_showonlogin, AppData.modulsettings.cdown_loginpos);

        $("#formLogin").show();
        $("#formReg").hide();
        $("#formLostPass").hide();
        $("#formTwofactor").hide();

        if (AppData.modulsettings.show_login_form) {
            $("#landing nav").show();
        } else {
            $("#landing nav").hide();
        }

        let $layouts = $('main');
        /* Set Title*/
        $layouts.find('.header-primary .data-title').text(AppData.modulsettings.title[localState.lang]);

        /* Set SubTitle */
        $layouts.find('.header-primary .data-subtitle').text(AppData.modulsettings.subTitle[localState.lang]);
    }

    function BuildFromSource() {
        $.post('api/', {
            do: 'getModulSettings'
        }, function (data) {
            AppData.modulsettings = data;
            Init();
            data = null;
        })
    }

    return {
        Init: Init,
        BuildFromSource: BuildFromSource
    }
})();
